/**
 * 营养配置模块
 * 职责：营养素标准配置、NRV参考值等
 */

/**
 * GB 28050-2011 营养素参考值（NRV）
 * 用于计算营养素参考值百分比（NRV%）
 */
export const NRV_REFERENCE = {
  '能量': { 
    value: 8400, 
    unit: '千焦', 
    unitEn: 'kJ',
    displayName: '能量',
    displayNameEn: 'Energy'
  },
  '蛋白质': { 
    value: 60, 
    unit: '克', 
    unitEn: 'g',
    displayName: '蛋白质',
    displayNameEn: 'Protein'
  },
  '脂肪': { 
    value: 60, 
    unit: '克', 
    unitEn: 'g',
    displayName: '脂肪',
    displayNameEn: 'Fat'
  },
  '饱和脂肪酸': { 
    value: 20, 
    unit: '克', 
    unitEn: 'g',
    displayName: '饱和脂肪酸',
    displayNameEn: 'Saturated Fat'
  },
  '碳水化合物': { 
    value: 300, 
    unit: '克', 
    unitEn: 'g',
    displayName: '碳水化合物',
    displayNameEn: 'Carbohydrate'
  },
  '糖': { 
    value: 50, 
    unit: '克', 
    unitEn: 'g',
    displayName: '糖',
    displayNameEn: 'Sugar'
  },
  '钠': { 
    value: 2000, 
    unit: '毫克', 
    unitEn: 'mg',
    displayName: '钠',
    displayNameEn: 'Sodium'
  },
  '膳食纤维': { 
    value: 25, 
    unit: '克', 
    unitEn: 'g',
    displayName: '膳食纤维',
    displayNameEn: 'Dietary Fiber'
  },
  '维生素A': { 
    value: 800, 
    unit: '微克视黄醇当量', 
    unitEn: 'μg RE',
    displayName: '维生素A',
    displayNameEn: 'Vitamin A'
  },
  '维生素C': { 
    value: 100, 
    unit: '毫克', 
    unitEn: 'mg',
    displayName: '维生素C',
    displayNameEn: 'Vitamin C'
  },
  '钙': { 
    value: 800, 
    unit: '毫克', 
    unitEn: 'mg',
    displayName: '钙',
    displayNameEn: 'Calcium'
  },
  '铁': { 
    value: 15, 
    unit: '毫克', 
    unitEn: 'mg',
    displayName: '铁',
    displayNameEn: 'Iron'
  },
  '锌': { 
    value: 15, 
    unit: '毫克', 
    unitEn: 'mg',
    displayName: '锌',
    displayNameEn: 'Zinc'
  },
  '维生素D': { 
    value: 5, 
    unit: '微克', 
    unitEn: 'μg',
    displayName: '维生素D',
    displayNameEn: 'Vitamin D'
  },
  '维生素E': { 
    value: 14, 
    unit: '毫克α-生育酚当量', 
    unitEn: 'mg α-TE',
    displayName: '维生素E',
    displayNameEn: 'Vitamin E'
  },
  '维生素B1': { 
    value: 1.4, 
    unit: '毫克', 
    unitEn: 'mg',
    displayName: '维生素B1',
    displayNameEn: 'Vitamin B1'
  },
  '维生素B2': { 
    value: 1.4, 
    unit: '毫克', 
    unitEn: 'mg',
    displayName: '维生素B2',
    displayNameEn: 'Vitamin B2'
  },
  '烟酸': { 
    value: 14, 
    unit: '毫克', 
    unitEn: 'mg',
    displayName: '烟酸',
    displayNameEn: 'Niacin'
  },
  '维生素B6': { 
    value: 1.4, 
    unit: '毫克', 
    unitEn: 'mg',
    displayName: '维生素B6',
    displayNameEn: 'Vitamin B6'
  },
  '叶酸': { 
    value: 400, 
    unit: '微克', 
    unitEn: 'μg',
    displayName: '叶酸',
    displayNameEn: 'Folate'
  },
  '维生素B12': { 
    value: 2.4, 
    unit: '微克', 
    unitEn: 'μg',
    displayName: '维生素B12',
    displayNameEn: 'Vitamin B12'
  },
  '生物素': { 
    value: 30, 
    unit: '微克', 
    unitEn: 'μg',
    displayName: '生物素',
    displayNameEn: 'Biotin'
  },
  '泛酸': { 
    value: 5, 
    unit: '毫克', 
    unitEn: 'mg',
    displayName: '泛酸',
    displayNameEn: 'Pantothenic Acid'
  },
  '磷': { 
    value: 700, 
    unit: '毫克', 
    unitEn: 'mg',
    displayName: '磷',
    displayNameEn: 'Phosphorus'
  },
  '钾': { 
    value: 2000, 
    unit: '毫克', 
    unitEn: 'mg',
    displayName: '钾',
    displayNameEn: 'Potassium'
  },
  '镁': { 
    value: 300, 
    unit: '毫克', 
    unitEn: 'mg',
    displayName: '镁',
    displayNameEn: 'Magnesium'
  }
};

/**
 * 营养素标准单位映射
 * 根据GB 28050标准
 */
export const STANDARD_UNITS = {
  '能量': '千焦',
  '蛋白质': '克',
  '脂肪': '克',
  '饱和脂肪酸': '克',
  '碳水化合物': '克',
  '糖': '克',
  '钠': '毫克',
  '膳食纤维': '克',
  '维生素A': '微克视黄醇当量',
  '维生素C': '毫克',
  '钙': '毫克',
  '铁': '毫克',
  '锌': '毫克',
  '维生素D': '微克',
  '维生素E': '毫克α-生育酚当量',
  '维生素B1': '毫克',
  '维生素B2': '毫克',
  '烟酸': '毫克',
  '维生素B6': '毫克',
  '叶酸': '微克',
  '维生素B12': '微克',
  '生物素': '微克',
  '泛酸': '毫克',
  '磷': '毫克',
  '钾': '毫克',
  '镁': '毫克'
};

/**
 * GB 28050标准必填营养素（核心营养素）
 * 预包装食品必须标示的营养成分
 */
export const REQUIRED_NUTRIENTS = [
  '能量',
  '蛋白质',
  '脂肪',
  '饱和脂肪酸',
  '碳水化合物',
  '糖',
  '钠'
];

/**
 * 营养素显示顺序（推荐）
 */
export const NUTRIENT_DISPLAY_ORDER = [
  '能量',
  '蛋白质',
  '脂肪',
  '饱和脂肪酸',
  '碳水化合物',
  '糖',
  '钠',
  '膳食纤维',
  '维生素A',
  '维生素C',
  '钙',
  '铁',
  '锌',
  '维生素D',
  '维生素E',
  '维生素B1',
  '维生素B2',
  '烟酸',
  '维生素B6',
  '叶酸',
  '维生素B12',
  '生物素',
  '泛酸',
  '磷',
  '钾',
  '镁'
];

/**
 * 获取营养素的标准单位
 * @param {string} nutrientName - 营养素名称
 * @returns {string} 标准单位
 */
export function getStandardUnit(nutrientName) {
  return STANDARD_UNITS[nutrientName] || '克';
}

/**
 * 获取营养素的NRV参考值
 * @param {string} nutrientName - 营养素名称
 * @returns {number|null} NRV参考值，如果不存在返回null
 */
export function getNRVReference(nutrientName) {
  const nrv = NRV_REFERENCE[nutrientName];
  return nrv ? nrv.value : null;
}

/**
 * 检查营养素是否必填
 * @param {string} nutrientName - 营养素名称
 * @returns {boolean} 是否必填
 */
export function isRequiredNutrient(nutrientName) {
  return REQUIRED_NUTRIENTS.includes(nutrientName);
}

/**
 * 获取所有营养素名称列表
 * @returns {string[]} 营养素名称列表
 */
export function getAllNutrientNames() {
  return Object.keys(NRV_REFERENCE);
}

/**
 * 获取必填营养素列表
 * @returns {string[]} 必填营养素名称列表
 */
export function getRequiredNutrientNames() {
  return [...REQUIRED_NUTRIENTS];
}

/**
 * 单位别名映射表
 * 用于识别和转换不同的单位表示方式
 */
export const UNIT_ALIASES = {
  '克': ['g', 'G', '克', 'gram', 'grams'],
  '毫克': ['mg', 'MG', '毫克', 'milligram', 'milligrams'],
  '微克': ['μg', 'ug', 'UG', '微克', 'microgram', 'micrograms', 'mcg', 'MCG'],
  '千焦': ['kJ', 'KJ', '千焦', 'kilojoule', 'kilojoules'],
  '千卡': ['kcal', 'KCAL', '千卡', 'kilocalorie', 'kilocalories', '卡路里'],
  '微克视黄醇当量': ['μg RE', 'ug RE', 'UG RE', '微克视黄醇当量', 'μgRE', 'ugRE'],
  '毫克α-生育酚当量': ['mg α-TE', 'mg α-TE', '毫克α-生育酚当量', 'mg α-TE', 'mgα-TE']
};

/**
 * 单位转换规则
 * 定义如何在不同单位之间进行转换
 */
export const UNIT_CONVERSIONS = {
  // 克相关转换
  '克_to_毫克': (value) => value * 1000,
  '毫克_to_克': (value) => value / 1000,
  '克_to_微克': (value) => value * 1000000,
  '微克_to_克': (value) => value / 1000000,
  '毫克_to_微克': (value) => value * 1000,
  '微克_to_毫克': (value) => value / 1000,
  // 能量转换
  '千焦_to_千卡': (value) => value / 4.184,
  '千卡_to_千焦': (value) => value * 4.184
};

/**
 * GB 28050 修约规则配置
 * 定义不同营养素的修约精度规则
 */
export const ROUNDING_RULES = {
  // 能量、钠：按整数显示
  '能量': { decimals: 0, method: 'round' },
  // 蛋白质、脂肪、碳水化合物：固定保留 1 位小数
  '蛋白质': { decimals: 1, method: 'round', keepTrailingZeros: true },
  '脂肪': { decimals: 1, method: 'round', keepTrailingZeros: true },
  '饱和脂肪酸': { decimals: 1, method: 'round' },
  '碳水化合物': { decimals: 1, method: 'round', keepTrailingZeros: true },
  '糖': { decimals: 1, method: 'round' },
  '膳食纤维': { decimals: 1, method: 'round' },
  '钠': { decimals: 0, method: 'round' },
  // 维生素和矿物质：多数保留1位小数（特殊项保持原有精度）
  '维生素A': { decimals: 1, method: 'round' },
  '维生素C': { decimals: 1, method: 'round' },
  '钙': { decimals: 1, method: 'round' },
  '铁': { decimals: 1, method: 'round' },
  '锌': { decimals: 1, method: 'round' },
  '维生素D': { decimals: 1, method: 'round' },
  '维生素E': { decimals: 1, method: 'round' },
  '维生素B1': { decimals: 2, method: 'round' },
  '维生素B2': { decimals: 2, method: 'round' },
  '烟酸': { decimals: 1, method: 'round' },
  '维生素B6': { decimals: 2, method: 'round' },
  '叶酸': { decimals: 1, method: 'round' },
  '维生素B12': { decimals: 2, method: 'round' },
  '生物素': { decimals: 1, method: 'round' },
  '泛酸': { decimals: 1, method: 'round' },
  '磷': { decimals: 1, method: 'round' },
  '钾': { decimals: 1, method: 'round' },
  '镁': { decimals: 1, method: 'round' }
};

/**
 * 根据单位别名获取标准单位
 * @param {string} unitAlias - 单位别名
 * @returns {string|null} 标准单位名称，如果未找到返回null
 */
export function getStandardUnitFromAlias(unitAlias) {
  if (!unitAlias) return null;
  
  const normalizedAlias = unitAlias.trim();
  
  for (const [standardUnit, aliases] of Object.entries(UNIT_ALIASES)) {
    if (aliases.includes(normalizedAlias)) {
      return standardUnit;
    }
  }
  
  return null;
}

/**
 * 转换单位
 * @param {string|number} value - 数值
 * @param {string} fromUnit - 源单位
 * @param {string} toUnit - 目标单位
 * @returns {number|null} 转换后的数值，如果无法转换返回null
 */
export function convertUnit(value, fromUnit, toUnit) {
  if (fromUnit === toUnit) return parseFloat(value);
  
  const numValue = parseFloat(value);
  if (isNaN(numValue)) return null;
  
  // 标准化单位名称
  const standardFromUnit = getStandardUnitFromAlias(fromUnit) || fromUnit;
  const standardToUnit = getStandardUnitFromAlias(toUnit) || toUnit;
  
  if (standardFromUnit === standardToUnit) return numValue;
  
  // 执行转换
  const conversionKey = `${standardFromUnit}_to_${standardToUnit}`;
  if (UNIT_CONVERSIONS[conversionKey]) {
    return UNIT_CONVERSIONS[conversionKey](numValue);
  }
  
  // 尝试反向转换
  const reverseKey = `${standardToUnit}_to_${standardFromUnit}`;
  if (UNIT_CONVERSIONS[reverseKey]) {
    return numValue / UNIT_CONVERSIONS[reverseKey](1);
  }
  
  return null;
}

/**
 * 获取营养素的修约规则
 * @param {string} nutrientName - 营养素名称
 * @returns {Object} 修约规则对象
 */
export function getRoundingRule(nutrientName) {
  return ROUNDING_RULES[nutrientName] || { decimals: 1, method: 'conditional', threshold: 1 };
}

export default {
  NRV_REFERENCE,
  STANDARD_UNITS,
  REQUIRED_NUTRIENTS,
  NUTRIENT_DISPLAY_ORDER,
  UNIT_ALIASES,
  UNIT_CONVERSIONS,
  ROUNDING_RULES,
  getStandardUnit,
  getNRVReference,
  isRequiredNutrient,
  getAllNutrientNames,
  getRequiredNutrientNames,
  getStandardUnitFromAlias,
  convertUnit,
  getRoundingRule
};

